import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from '@linktivity/link-ui';
import { isHardware } from '@triplabo/web/utils';
import emptyIcon from '@triplabo/web/assets/empty.png';

import styles from './empty.module.css';

const Empty: React.FC = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/change?type=dropoff');
  };

  return (
    <div className={styles.empty}>
      <img className={styles.emptyIcon} src={emptyIcon} alt="empty" />
      <div className={styles.emptyTitle}>{t('views.pickup.empty')}</div>
      <div className={styles.emptyTip}>{t('views.pickup.emptyTip')}</div>
      {!isHardware && (
        <Button className={styles.emptyButton} onClick={handleClick}>
          {t('views.pickup.emptyButton')}
        </Button>
      )}
    </div>
  );
});

export default Empty;
